import Component from './pills';

export default Component;